import React, { useState, useContext } from 'react';
import { WelletContext } from '../../context/WelletContext';
import { signInWithCustomToken } from 'firebase/auth';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { exchangeToken } from '../../actions/associatesActions';
import { getAuth } from 'firebase/auth';
import { getQueryString } from '../../helpers/url';
import { useTranslation } from 'react-i18next';
import ButtonProccessing from '../../components/Common/ButtonProccessing/ButtonProccessing';
import ContentApp from '../../components/ContentApp';
import Header from '../../components/Common/Header/Header';
import ErrorBox from '../../components/Common/ErrorBox/ErrorBox';
import useForm from '../../helpers/useForm';
import InputFormBorder from '../../components/Common/InputFormBorder/InputFormBorder';
import { clearWorkCredential } from '../../actions/workCredentialActions';
import FixedButton from '../../components/Common/FixedButton/FixedButton';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';

const SignUpCreatePasswordSimple = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const tenant = useSelector((state) => state.app.tenantId);
  const language = useSelector((state) => state.app.language);
  const auth = getAuth();
  const email = getQueryString('email');
  const countryCode = getQueryString('countryCode');
  const phone = getQueryString('phone');
  const rp = getQueryString('rp');
  const token = getQueryString('token');
  const CityId = getQueryString('city');
  const firstName = getQueryString('firstName');
  const lastName = getQueryString('lastName');
  const welletContext = useContext(WelletContext);
  const [error, setError] = useState(null);
  const [buttonStatus, setButtonStatus] = useState('NORMAL');
  const location = useLocation();
  const affiliateType = getQueryString('affiliateType');
  const sectorAffiliate = getQueryString('sectorAffiliate');
  const hotelName = getQueryString('hotelName');
  const jobtitle = getQueryString('jobtitle')
  const workUnit = getQueryString('workUnit')

  const onContinueHandle = (user) => {
    exchangeToken(dispatch, user, () => history.push('/'));
  };
  const selfie = location.state?.selfie;

  function validate(values) {
    let errors = {};
    const rexCapital = /[A-Z]/;
    const rexNumber = /[0-9]/;
    const rexSpace = /\s/;
    if (!values.password) {
      errors.password = t('passwordError.PASSWORD_TOO_SHORT');
    } else if (values.password.length < 8) {
      errors.password = t('passwordError.PASSWORD_TOO_SHORT');
    } else if (!rexCapital.test(values.password)) {
      errors.password = t('passwordError.PASSWORD_HAS_NOT_UPPERCASE_LETTER');
    } else if (!rexNumber.test(values.password)) {
      errors.password = t('passwordError.PASSWORD_HAS_NOT_NUMBER');
    } else if (rexSpace.test(values.password)) {
      errors.password = t('passwordError.PASSWORD_CONTAIN_SPACES');
    } else if (values.password !== values.passwordconfirmation) {
      errors.passwordconfirmation = t('passwordError.PASSWORD_NOT_MATCH');
    }
    return errors;
  }

  const sendForm = async () => {
    setButtonStatus('INPROGRESS');
    setError(null);
    try {
      const result = await welletContext.apis.tickets.post(
        `register/simple/identity`,
        {
          email: email,
          phone: phone,
          password: values.password,
          confirmation: values.passwordconfirmation,
          tenantId: tenant,
          countryCode,
          RpId: rp === '0' ? null : rp,
          language,
          CityId: CityId,
          firstName,
          lastName,
          ProfilePicUrl: selfie,
          sector: sectorAffiliate,
          workUnit: workUnit,
          jobtitle: jobtitle,
          affiliateType: affiliateType,
          company: hotelName,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (result.data.verification) {
        dispatch(clearWorkCredential());
        setButtonStatus('FINISHED');
        const userCredentials = await signInWithCustomToken(auth, result.data.token);
        onContinueHandle(userCredentials.user);
      } else {
        setButtonStatus('NORMAL');
        setError('x');
      }
    } catch (error) {
      setButtonStatus('NORMAL');
      setError('x');
      console.error(error);
    }
  };

  const { values, errors, handleChange, handleSubmit } = useForm(sendForm, validate);

  return (
    <>
      <Header title={''} hasBackground={true} />
      <ContentApp background={true}>
        <div>
          <div className='text-left'>
            <div className='font-medium mt-3 bold' style={{ color: '#fff' }}>
              {t('signUp.choosePassword')}
            </div>
            <div className='mt-2 subtitle font-small' style={{ color: 'var(--color-font-gray)' }}>
              {t('signUp.passwordDescription')}
            </div>
          </div>
          <form className='mt-4' onSubmit={handleSubmit}>
            <div className='mt-4'>
              <InputFormBorder
                name='password'
                type='password'
                value={values.password}
                error={errors.password}
                placeholder={t('password')}
                onChange={handleChange}
              />
            </div>
            <div className='mt-4'>
              <InputFormBorder
                name={'passwordconfirmation'}
                type={'password'}
                value={values.passwordconfirmation}
                error={errors.passwordconfirmation}
                placeholder={t('repeatPassword')}
                onChange={handleChange}
              />
            </div>
            {error ? (
              <div className='mt-3'>
                <ErrorBox title='Error' description={t('passwordError.CHANGE_PASSWORD_TITLE')} />
              </div>
            ) : null}
            <div className='mt-3 d-flex justify-content-center'>
              <FixedButton>
                <ButtonProccessing
                  size={'large'}
                  text={t('continue')}
                  inProgressText='Procesando'
                  status={buttonStatus}
                  checkSize='30px'
                  arrow={true}
                  backgroundColor='var(--color-primary)'
                  color='#000'
                  iconColor='#000'
                  className={'d-flex align-items-center justify-content-center'}
                />
              </FixedButton>
            </div>
          </form>
        </div>
      </ContentApp>
    </>
  );
};

export default SignUpCreatePasswordSimple;
